import React from 'react';
import { isChunkLoadError, reloadOnceForChunkError } from '../utils/lazyLoad';

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Route error:', error, info);
    reloadOnceForChunkError(error);
  }

  render() {
    if (this.state.hasError) {
      const isChunkError = isChunkLoadError(this.state.error);
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2 style={{ color: '#ef4444' }}>{isChunkError ? 'Updating app' : 'Something went wrong'}</h2>
          <p style={{ color: '#6b7280', marginBottom: '1rem' }}>{this.state.error?.message}</p>
          {isChunkError && (
            <p style={{ color: '#6b7280', marginBottom: '1rem' }}>
              A new version is available. Refreshing should load the latest files.
            </p>
          )}
          <button
            onClick={() => (isChunkError ? window.location.reload() : this.setState({ hasError: false, error: null }))}
            style={{ padding: '0.5rem 1rem', background: '#6366f1', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
          >
            {isChunkError ? 'Refresh' : 'Try Again'}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RouteErrorBoundary;
